import { call, put } from 'redux-saga/effects'
import { getAccountManager } from '../apiModules/accountManager'
import { accountManagerEntities } from '../reducks'

export function* fetchAccountManagerEntitiesSaga(companyId) {
  const response = yield call(getAccountManager, companyId)
  yield put(accountManagerEntities.addItem(response.result.id, response.result))
  return response
}
